import api from '../api/client';

export const sociosService = {
  listar: (organizadorId, params = {}) => {
    const queryParams = new URLSearchParams();
    if (params.search) queryParams.append('search', params.search);
    if (params.status) queryParams.append('status', params.status);
    if (params.data_vencimento_inicio) queryParams.append('data_vencimento_inicio', params.data_vencimento_inicio);
    if (params.data_vencimento_fim) queryParams.append('data_vencimento_fim', params.data_vencimento_fim);
    if (params.tem_vigencia !== undefined && params.tem_vigencia !== null) queryParams.append('tem_vigencia', params.tem_vigencia);
    if (params.page) queryParams.append('page', params.page);
    if (params.per_page) queryParams.append('per_page', params.per_page);
    const query = queryParams.toString();
    return api.get(`/organizadores/${organizadorId}/socios${query ? `?${query}` : ''}`);
  },

  resumo: (organizadorId) =>
    api.get(`/organizadores/${organizadorId}/socios/resumo`),

  criar: (organizadorId, dados) =>
    api.post(`/organizadores/${organizadorId}/socios`, dados),

  atualizar: (organizadorId, sociedadeId, dados) =>
    api.put(`/organizadores/${organizadorId}/socios/${sociedadeId}`, dados),

  darBaixa: (organizadorId, sociedadeId, dados = {}) =>
    api.post(`/organizadores/${organizadorId}/socios/${sociedadeId}/baixa`, dados),

  estornar: (organizadorId, sociedadeId) =>
    api.post(`/organizadores/${organizadorId}/socios/${sociedadeId}/estornar`),

  renovar: (organizadorId, sociedadeId, dados = {}) =>
    api.post(`/organizadores/${organizadorId}/socios/${sociedadeId}/renovar`, dados),

  cancelar: (organizadorId, sociedadeId) =>
    api.post(`/organizadores/${organizadorId}/socios/${sociedadeId}/cancelar`),

  uploadComprovante: (organizadorId, sociedadeId, file) => {
    const form = new FormData();
    form.append('file', file);
    return api.post(`/organizadores/${organizadorId}/socios/${sociedadeId}/comprovantes`, form, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  },

  listarComprovantes: (organizadorId, sociedadeId) =>
    api.get(`/organizadores/${organizadorId}/socios/${sociedadeId}/comprovantes`),

  excluirComprovante: (organizadorId, sociedadeId, compId) =>
    api.delete(`/organizadores/${organizadorId}/socios/${sociedadeId}/comprovantes/${compId}`),

  desconto: (organizadorId, sociedadeId) =>
    api.get(`/organizadores/${organizadorId}/socios/${sociedadeId}/desconto`),

  relatorio: (organizadorId, params = {}) => {
    const queryParams = new URLSearchParams();
    if (params.status) queryParams.append('status', params.status);
    if (params.data_vencimento_inicio) queryParams.append('data_vencimento_inicio', params.data_vencimento_inicio);
    if (params.data_vencimento_fim) queryParams.append('data_vencimento_fim', params.data_vencimento_fim);
    const query = queryParams.toString();
    return api.get(`/organizadores/${organizadorId}/socios/relatorio${query ? `?${query}` : ''}`);
  },

  relatorioPdf: (organizadorId, params = {}) => {
    const queryParams = new URLSearchParams();
    if (params.status) queryParams.append('status', params.status);
    if (params.data_vencimento_inicio) queryParams.append('data_vencimento_inicio', params.data_vencimento_inicio);
    if (params.data_vencimento_fim) queryParams.append('data_vencimento_fim', params.data_vencimento_fim);
    const query = queryParams.toString();
    return api.get(`/organizadores/${organizadorId}/socios/relatorio/pdf${query ? `?${query}` : ''}`, { responseType: 'blob' });
  },

  exportarXlsx: (organizadorId, params = {}) => {
    const queryParams = new URLSearchParams();
    if (params.search) queryParams.append('search', params.search);
    if (params.status) queryParams.append('status', params.status);
    if (params.data_vencimento_inicio) queryParams.append('data_vencimento_inicio', params.data_vencimento_inicio);
    if (params.data_vencimento_fim) queryParams.append('data_vencimento_fim', params.data_vencimento_fim);
    if (params.tem_vigencia !== undefined && params.tem_vigencia !== null) queryParams.append('tem_vigencia', params.tem_vigencia);
    const query = queryParams.toString();
    return api.get(`/organizadores/${organizadorId}/socios/exportar${query ? `?${query}` : ''}`, { responseType: 'blob' });
  },

  acoesLote: (organizadorId, sociedadeIds, acao) =>
    api.post(`/organizadores/${organizadorId}/socios/acoes-lote`, { sociedade_ids: sociedadeIds, acao }),

  toggleSocio: (organizadorId, clienteId, dados) =>
    api.patch(`/organizadores/${organizadorId}/clientes/${clienteId}/socio`, dados),
};

